import { useCallback } from 'react';
import { supabase } from '../supabaseClient';
import { useSupabaseQuery } from './useSupabaseQuery';

/**
 * Fila de fuzzy matches de empresas pendentes de revisão humana.
 * Produzida por find_empresa_by_cascade quando nenhum candidato passa do threshold.
 */
export function useMatchPendente() {
  const query = useSupabaseQuery(
    (sb) =>
      sb
        .from('empresa_match_pendente')
        .select('*')
        .eq('status', 'pendente')
        .order('created_at', { ascending: false }),
    []
  );

  const resolve = useCallback(async ({ pendingId, action, empresaId, resolvedBy }) => {
    const { data, error } = await supabase.rpc('resolve_empresa_match', {
      p_pending_id: pendingId,
      p_action: action,
      p_empresa_id: empresaId,
      p_resolved_by: resolvedBy,
    });
    if (error) throw error;
    return data;
  }, []);

  return { ...query, resolve };
}
